'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MoonIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.001 13.7501C19.152 13.7501 20.2454 13.4988 21.2283 13.048C20.7069 17.6813 16.7755 21.2824 12.0029 21.2824C6.8754 21.2824 2.71875 17.1257 2.71875 11.9983C2.71875 7.2257 6.31983 3.29424 10.9531 2.7728C10.5023 3.75571 10.251 4.84909 10.251 6.0001C10.251 10.2803 13.7208 13.7501 18.001 13.7501Z",
        stroke: "currentColor",
        strokeLinecap: "round"
      }
    )
  }
);
const VpMoonIcon = forwardRef(MoonIcon);

export { VpMoonIcon as default };
